import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { FormAlert } from '../../../components/FormAlert';
import { IProjectDetailsStore } from '../projectDetails.store';
import { IProjectDetailsToolsStore } from '../sub/tools/projectDetailsTools.store';

export const GlobalValidationErrorsContainer = observer((): ReactElement => {
  const projectDetailsStore = useInjection(IProjectDetailsStore.$);
  const projectDetailsToolsStore = useInjection(IProjectDetailsToolsStore.$);

  return (
    <ColumnLayout size='sm'>
      <FormAlert errors={projectDetailsStore.datasetsStatus} />
      <FormAlert errors={projectDetailsToolsStore.toolsStatus} />
    </ColumnLayout>
  );
});
